import { Discount } from "./discount";

export class PixData {
  appliedCoupons: Array<Discount>;//
  chargedUser: boolean;// Tela de alterar forma de pagamento
  discountedValue: number;//
  expirationDate: string;//
  errorMsg: string;//
  file: string;
  invoiceDate: string;
  invoiceId: string;
  pixExpiryTime: string;
  qrCode: string;
  remittanceConsultsInterval: number;
  remittanceId: string;
  status: string;
  totalValue: number;
  txid: string;

  //paymentChange
  planName: string;

  constructor(pixData?: any) {
    if(pixData){
      this.invoiceDate = pixData.invoiceDate;
      this.totalValue = pixData.totalValue;
      this.expirationDate = pixData.expirationDate;
      this.pixExpiryTime = pixData.pixExpiryTime;
      this.remittanceConsultsInterval = pixData.remittanceConsultsInterval;
      this.status = pixData.status;
      this.chargedUser = pixData.chargedUser;
      this.invoiceId = pixData.invoiceId;
      this.file = pixData.file;
      this.remittanceId = pixData.remittanceId;
      this.qrCode = pixData.qrCode;
      this.txid = pixData.txid;
      this.discountedValue = pixData.discountedValue;
      this.errorMsg = pixData.errorMsg;
      this.planName = pixData.planName;

      if(pixData.appliedCoupons && pixData.appliedCoupons.length){
        this.appliedCoupons = pixData.appliedCoupons.map(coupon => new Discount(coupon));
      }
    }
  }
}
